import React from 'react';
import { Header } from '../../../components/singleComponents/headers';

export function Teste() {
  return (
    <>
      <Header />
      <span>Olá</span>
      <input type="checkbox" />
    </>
  );
}
